<div class="wrapper">
  <div class="heading text-type-2">Add item posting</div>
  <form [formGroup]="form">
    @if (projectFilterOptions.length > 2) {
      <div class="filter-section mt-[40px]">
        <div class="project-filter-pill" [matMenuTriggerFor]="projectMenu">
          <span class="pill-text">{{ selectedProjectLabel }}</span>
          <mat-icon class="pill-chevron" svgIcon="chevron-down" />
        </div>
        <mat-menu #projectMenu="matMenu">
          @for (option of projectFilterOptions; track option.value) {
            <button (click)="selectProject(option.value)" mat-menu-item>
              {{ option.label }}
            </button>
          }
        </mat-menu>
      </div>
    }
    <div class="search-section mt-[20px]">
      <app-text-input
        [parentFormGroup]="form"
        [searchComponent]="true"
        controlName="searchText"
        placeholder="Search item postings"
        suffixIcon="search"
      />
    </div>
    <div class="results-section">

      @if (filteredItemPostingsList.length > 0 && focusedIn) {
        <div class="item-postings-list">
          @for (itemPosting of filteredItemPostingsList; track itemPosting; let first = $first; let last = $last) {
            <div
              (mousedown)="selectItemPostings(itemPosting)"
              [class.first]="first"
              [class.last]="last"
              class="each-item flex justify-start items-start gap-[16px]"
              >
              <div class="left flex justify-start items-center">
                <div class="icon-wrapper">
                  <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                </div>
              </div>
              <div class="right flex flex-col justify-center items-start gap-[2px]">
                <div class="item-heading text-type-6">{{ itemPosting.item }}</div>
                <div class="description text-type-14">{{ itemPosting.description }}</div>
                <div class="meta text-type-14">
                  {{ itemPosting.source_entity_extra_attributes?.project_name }}
                  · PRJ LINE: {{ itemPosting.source_entity_extra_attributes?.project_item_line_number }}
                  · LINE: {{ itemPosting.source_entity_extra_attributes?.contract_item_line_number }}
                  @if (itemPosting.source_entity_extra_attributes?.supplemental_description) {
                    · {{ itemPosting.source_entity_extra_attributes.supplemental_description | uppercase }}
                  }
                </div>
                <div class="uom text-type-14">UOM: {{ itemPosting.uom }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </form>
</div>
